import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import PlaceholderReportScreen from './PlaceholderReportScreen';

const ExtraPaxReportScreen: React.FC = () => (
  <PlaceholderReportScreen
    title="Extra Pax Report"
    description="Extra adult / child usage and the additional revenue earned."
    icon={<IconSystem.user size={18} />}
    phaseLabel="Coming in Phase 5"
    comingSoonHint="Counts pax above the room base capacity and the extra-pax revenue."
  />
);
export default ExtraPaxReportScreen;
